<template>
  <section class="privateWallet">
    <div class="privateWallet-con">
      <div class="payments-top">
          <div class="img-1">
            <img src="../../assets/img/Mockup9@2x.png" alt="">
          </div>
          <div :class="['img-2', 'p-payments-card', {rotateKa: anime}]">
            <img src="../../assets/img/xpass1@2x.png" alt="">
          </div>
      </div>
      <div class="text"><title-desc-tutorial :subType="true" :title="$t('overview.manageAssets.title')" :descList="descList" :videoList="videoList" :theme="'theme_assets'"></title-desc-tutorial></div>
    </div>
  </section>
</template>

<script>
import TitleDescTutorial from '../../components/common/title-desc-tutorial'

export default {
  components: {
    TitleDescTutorial
  },
  data() {
    return {
      descList: [
        this.$t('overview.manageAssets.list1'),
        this.$t('overview.manageAssets.list2'),
        this.$t('overview.manageAssets.list3'),
        this.$t('overview.manageAssets.list4')
      ],
      videoList: [
        {
          title: this.$t('overview.manageAssets.tutorial1'),
          url: 'https://www.youtube.com/watch?v=Tvz8Ceczl10'
        }
      ],
      imgNum: 0,
      imgElNum: 0,
      anime: false
    }
  },
  methods: {
    computImg () {
      this.imgNum += 1
      if (this.imgElNum === 0) {
        return false
      }
      if (this.imgNum === this.imgElNum) {
        this.mountAnime()
      }
    },
    mountAnime () {
      window.sr.reveal('.p-payments-card', {
        viewFactor: .3,
        scale: 1,
        duration: 0,
        origin: 'left',
        distance: '0',
        easing: 'ease-in',
        opacity: 1,
        delay: 500,
        afterReveal: () => {
          this.anime = true
        },
      })
    }
  },
  mounted () {
    let imgs = this.$el.getElementsByTagName('img')
    this.imgElNum = imgs.length
    for (let i = 0; i < imgs.length; i++) {
      let src = imgs[i].src
      imgs[i].src = ''
      imgs[i].addEventListener('load', () => {
        this.computImg()
      })
      imgs[i].src = src
    }
  }
}
</script>

<style lang="scss" scoped>
.privateWallet {
  background-color: #FFF;
}
.privateWallet-con {
  max-width: 1200px;
  margin: auto;
  padding: 120px 20px 117px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.text {
  max-width: 480px;
  width: auto;
}

.payments-top{
  min-width: 490px;
  div {
    display: inline-block;
    position: relative;

    img {
      display: block;
    }
  }
  div::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .img-1 {
    &::before {
      width: 223px;
      height: 457px;
      border-radius: 6px;
    }

    img {
      max-width: 305px;
      filter: drop-shadow(0 8px 20px transparent);
    }
  }

  .img-2 {
    bottom: 44px;
    left: -102px;
    transform: rotate(0deg);
    transform-origin: right bottom;
    transition: all .3s;
    &::before {
      width: 97%;
      height: 97%;
      box-shadow: 0 5px 30px 0 rgba(0,0,0,0.40);
      border-radius: 15px;
    }

    img {
      max-width: 181px;
    }
  }
}

.rotateKa {
    transform: rotate(16deg)!important;
}


@media screen and (max-width: 768px) {
  .privateWallet-con {
    flex-direction: column-reverse;
    padding: 56px 20px 24px;
  }
  .text {
    max-width: 100%;
  }
  .payments-top {
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .payments-top .img-1 img {
    max-width: 60%;
  }
  .payments-top .img-2 {
    margin: auto;
    width: 34%;
    position: absolute;
    left: 40%;
  }
  .payments-top .img-2 img {
    max-width: 100%;
  }
}
</style>